import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

/* -----------------------------
   Utils
----------------------------- */
function classNames(...arr) {
  return arr.filter(Boolean).join(" ");
}

/* -----------------------------
   Icons
----------------------------- */
function Icon({ name, className = "h-5 w-5" }) {
  switch (name) {
    case "dashboard":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M4 5.8A1.8 1.8 0 0 1 5.8 4h4.4A1.8 1.8 0 0 1 12 5.8v4.4a1.8 1.8 0 0 1-1.8 1.8H5.8A1.8 1.8 0 0 1 4 10.2V5.8ZM14 5.8A1.8 1.8 0 0 1 15.8 4h2.4A1.8 1.8 0 0 1 20 5.8v8.4a1.8 1.8 0 0 1-1.8 1.8h-2.4a1.8 1.8 0 0 1-1.8-1.8V5.8ZM4 15.8A1.8 1.8 0 0 1 5.8 14h4.4a1.8 1.8 0 0 1 1.8 1.8v2.4a1.8 1.8 0 0 1-1.8 1.8H5.8A1.8 1.8 0 0 1 4 18.2v-2.4ZM14 19a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z"
            fill="currentColor"
          />
        </svg>
      );

    case "calendar":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M7 3v3M17 3v3M4 9h16"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
          />
          <rect
            x="4"
            y="5"
            width="16"
            height="16"
            rx="3"
            stroke="currentColor"
            strokeWidth="2.1"
          />
          <path
            d="M8 13h.01M12 13h.01M16 13h.01M8 17h.01M12 17h.01"
            stroke="currentColor"
            strokeWidth="2.8"
            strokeLinecap="round"
          />
        </svg>
      );

    case "ticket":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M5 6h14a1.7 1.7 0 0 1 1.7 1.7v1.4a2.3 2.3 0 0 0 0 5.8v1.4A1.7 1.7 0 0 1 19 18H5a1.7 1.7 0 0 1-1.7-1.7v-1.4a2.3 2.3 0 0 0 0-5.8V7.7A1.7 1.7 0 0 1 5 6Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M14 8.5v7M8 10h3.5M8 13h3"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      );

    case "invoice":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M7 3h10a2 2 0 0 1 2 2v16l-3-1.7-3 1.7-3-1.7L7 21l-2-1.2V5a2 2 0 0 1 2-2Z"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinejoin="round"
          />
          <path
            d="M9 8h6M9 12h6M9 16h4"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
          />
        </svg>
      );

    case "doctors":
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none">
      <path
        d="M7 3a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-.9A3 3 0 0 0 4 7v2a5 5 0 0 0 10 0V7a3 3 0 0 0-2-2.9V5a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1 5 5 0 0 1 5 5v1a7 7 0 0 1-6 6.92V17a3 3 0 0 0 6 0v-.18a3 3 0 1 1 2 0V17a5 5 0 0 1-10 0v-1.08A7 7 0 0 1 2 9V7a5 5 0 0 1 5-4Zm10 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
        fill="currentColor"
      />
    </svg>
  );

    case "settings":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M12 15.5A3.5 3.5 0 1 0 12 8a3.5 3.5 0 0 0 0 7.5Z"
            stroke="currentColor"
            strokeWidth="2.1"
          />
          <path
            d="M19.4 13.5c.1-.5.1-1 .1-1.5s0-1-.1-1.5l2-1.5-2-3.5-2.4 1a8 8 0 0 0-2.5-1.5L14.2 2h-4.4l-.3 2.5A8 8 0 0 0 7 6L4.6 5l-2 3.5 2 1.5c-.1.5-.1 1-.1 1.5s0 1 .1 1.5l-2 1.5 2 3.5 2.4-1a8 8 0 0 0 2.5 1.5l.3 2.5h4.4l.3-2.5A8 8 0 0 0 17 18l2.4 1 2-3.5-2-1.5Z"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "logout":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M10 17v1.5A1.5 1.5 0 0 1 8.5 20h-3A1.5 1.5 0 0 1 4 18.5v-13A1.5 1.5 0 0 1 5.5 4h3A1.5 1.5 0 0 1 10 5.5V7"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
          />
          <path
            d="M15 7l5 5-5 5M20 12H9"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case "spark":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M13 2 9.8 9.8 2 13l7.8 3.2L13 24l3.2-7.8L24 13l-7.8-3.2L13 2Z"
            fill="currentColor"
          />
        </svg>
      );

    case "plus":
      return (
        <svg className={className} viewBox="0 0 24 24" fill="none">
          <path
            d="M12 5v14M5 12h14"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
          />
        </svg>
      );

    default:
      return null;
  }
}

/* -----------------------------
   Sidebar item
----------------------------- */
function SidebarNavItem({ to, icon, label, badge, exact = false, match }) {
  const location = useLocation();

  const matched = match
    ? match(location.pathname)
    : exact
    ? location.pathname === to
    : location.pathname === to || location.pathname.startsWith(`${to}/`);

  return (
    <NavLink
      to={to}
      className={classNames(
        "group relative flex items-center gap-3 rounded-2xl px-3.5 py-3 text-sm font-semibold transition-all duration-200",
        matched
          ? "bg-white text-primary shadow-[0_12px_28px_rgba(15,23,42,0.08)]"
          : "text-slate-500 hover:bg-white/70 hover:text-slate-950"
      )}
      end={exact}
    >
      <span
        className={classNames(
          "absolute left-0 top-1/2 h-7 w-1 -translate-y-1/2 rounded-r-full transition-all",
          matched ? "bg-primary opacity-100" : "bg-transparent opacity-0"
        )}
      />

      <span
        className={classNames(
          "flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl transition",
          matched
            ? "bg-primary/10 text-primary"
            : "bg-slate-100 text-slate-500 group-hover:bg-primary/10 group-hover:text-primary"
        )}
      >
        <Icon name={icon} className="h-5 w-5" />
      </span>

      <span className="min-w-0 flex-1 truncate">{label}</span>

      {badge ? (
        <span
          className={classNames(
            "rounded-full px-2 py-0.5 text-[11px] font-bold",
            matched ? "bg-primary text-white" : "bg-slate-100 text-slate-500"
          )}
        >
          {badge}
        </span>
      ) : null}
    </NavLink>
  );
}

/* -----------------------------
   Mobile bottom nav item
----------------------------- */
function MobileNavItem({ to, icon, label, match }) {
  const location = useLocation();

  const matched = match
    ? match(location.pathname)
    : location.pathname === to || location.pathname.startsWith(`${to}/`);

  return (
    <NavLink
      to={to}
      className={classNames(
        "flex flex-1 flex-col items-center justify-center gap-1 rounded-2xl px-2 py-2 text-[11px] font-semibold transition",
        matched ? "bg-primary text-white" : "text-slate-500 hover:bg-slate-50"
      )}
    >
      <Icon name={icon} className="h-5 w-5" />
      <span>{label}</span>
    </NavLink>
  );
}

/* -----------------------------
   Layout
----------------------------- */
export const BOOKING_LAYOUT_PATHS = ["/patient/book-appointment"];

export function isBookingLayoutPath(pathname = "") {
  const path = pathname.replace(/\/+$/, "");
  return BOOKING_LAYOUT_PATHS.includes(path);
}

export default function PatientLayout({
  children,
  user ,
  brandSubtitle = "Patient Portal",
  onSignOut,
}) {
  const location = useLocation();

  const defaultUser = { name: "ThePulseCare User", email: "", initials: "U" }
  const _user = { 
      name: JSON.parse(localStorage.getItem("orbismed_patient_auth") || {})?.patient?.first_name || "ThePulseCare User",
      email: JSON.parse(localStorage.getItem("orbismed_patient_auth") || {})?.patient?.account?.email || "",
    }
  const isDashboard = (path) => path === "/patient" || path === "/patient/dashboard";
  // The booking/discovery route uses the full width for its own filter panel;
  // every other Patient route keeps the normal sidebar.
  const bookingLayout = isBookingLayoutPath(location.pathname);

  const navItems = [
    {
      to: "/patient/dashboard",
      icon: "dashboard",
      label: "Dashboard",
      match: isDashboard,
    },
    {
      to: "/patient/appointments",
      icon: "calendar",
      label: "Appointments",
    },
    {
      to: "/patient/doctors",
      icon: "doctors",
      label: "Doctors",
    },
    {
      to: "/patient/invoices",
      icon: "invoice",
      label: "Invoices",
    },
    {
      to: "/patient/tickets",
      icon: "ticket",
      label: "Tickets",
    },
    {
      to: "/patient/settings",
      icon: "settings",
      label: "Settings",
    },
  ];

  const currentLabel =
    navItems.find((item) =>
      item.match
        ? item.match(location.pathname)
        : location.pathname === item.to ||
          location.pathname.startsWith(`${item.to}/`)
    )?.label || "Patient Portal";

  return (
    <div className="w-full">
      <div className="flex gap-6">
        {/* Desktop Sidebar */}
        {bookingLayout ? null : (
        <aside className="hidden w-[300px] shrink-0 lg:block" data-testid="patient-sidebar">
          <div className="sticky top-6 overflow-hidden rounded-[28px] border border-slate-200/80 bg-white shadow-[0_24px_80px_rgba(15,23,42,0.10)]">
            {/* Brand block */}
            <div className="relative overflow-hidden p-5">
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "radial-gradient(circle at 20% 20%, rgba(var(--c-primary),0.20), transparent 34%), radial-gradient(circle at 80% 10%, rgba(var(--c-accent),0.22), transparent 28%), linear-gradient(135deg, rgba(248,250,252,1), rgba(255,255,255,1))",
                }}
              />

              <div className="relative">
                <div className="flex items-center gap-3">
                  {/* <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-primary to-sky-400 text-lg font-black text-white shadow-[0_16px_32px_rgba(14,165,233,0.30)]">
                    O
                  </div> */}

                  <div className="min-w-0">
                    <div className="truncate text-lg font-black leading-tight text-slate-950">
                      ThePulseCare
                    </div>
                    <div className="mt-0.5 text-xs font-semibold text-slate-500">
                      {brandSubtitle}
                    </div>
                  </div>
                </div>

                {/* <div className="mt-5 rounded-3xl border border-white/80 bg-white/70 p-4 shadow-sm backdrop-blur">
                  <div className="flex items-center gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                      <Icon name="spark" className="h-4 w-4" />
                    </div>

                    <div>
                      <div className="text-sm font-black text-slate-950">
                        Care workspace
                      </div>
                      <div className="mt-0.5 text-xs text-slate-500">
                        Manage visits, invoices & support
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            {/* Navigation */}
            <div className="px-4 pb-4">
              <div className="mb-2 px-2 text-[11px] font-black uppercase tracking-[0.18em] text-slate-400">
                Menu
              </div>

              <nav className="space-y-1.5">
                {navItems.map((item) => (
                  <SidebarNavItem
                    key={item.to}
                    to={item.to}
                    icon={item.icon}
                    label={item.label}
                    badge={item.badge}
                    match={item.match}
                  />
                ))}
              </nav>
            </div>

            {/* Quick action */}
            {/* <div className="mx-4 mb-4 rounded-[24px] bg-slate-950 p-4 text-white shadow-[0_18px_40px_rgba(15,23,42,0.24)]">
              <div className="flex items-start gap-3">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-white/10 text-sky-200">
                  <Icon name="plus" className="h-5 w-5" />
                </div>

                <div className="min-w-0">
                  <div className="text-sm font-black">Need help?</div>
                  <div className="mt-1 text-xs leading-5 text-slate-300">
                    Raise a ticket and track updates from your care team.
                  </div>

                  <Link
                    to="/patient/tickets/new"
                    className="mt-3 inline-flex items-center rounded-xl bg-white px-3 py-2 text-xs font-black text-slate-950 transition hover:bg-slate-100"
                  >
                    Raise ticket
                  </Link>
                </div>
              </div>
            </div> */}

            {/* User block */}
            <div className="border-t border-slate-100 bg-slate-50/80 p-4">
              <div className="flex items-center gap-3">
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-slate-800 to-slate-600 font-black text-white shadow-sm">
                  {_user.initials || _user.name?.[0] || "U"}
                </div>

                <div className="min-w-0 flex-1">
                  <div className="truncate text-sm font-black text-slate-950">
                    {_user.name}
                  </div>
                  <div className="truncate text-xs text-slate-500">
                    {_user.email}
                  </div>
                </div>

                <button
                  type="button"
                  onClick={onSignOut}
                  className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-500 transition hover:border-rose-200 hover:bg-rose-50 hover:text-rose-600"
                  title="Sign out"
                >
                  <Icon name="logout" className="h-5 w-5" />
                </button>
              </div>
            </div>
          </div>
        </aside>
        )}

        {/* Main */}
        <main className="min-w-0 flex-1 pb-24 lg:pb-0">{children}</main>
      </div>

      {/* Mobile header */}
      <div className="fixed left-3 right-3 top-3 z-40 rounded-3xl border border-slate-200 bg-white/90 px-4 py-3 shadow-[0_16px_50px_rgba(15,23,42,0.12)] backdrop-blur lg:hidden">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-gradient-to-br from-primary to-sky-400 font-black text-white">
              O
            </div>
            <div>
              <div className="text-sm font-black text-slate-950">
                {currentLabel}
              </div>
              <div className="text-xs text-slate-500">OrbisMed</div>
            </div>
          </div>

          <button
            type="button"
            onClick={onSignOut}
            className="flex h-10 w-10 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-500"
          >
            <Icon name="logout" className="h-5 w-5" />
          </button>
        </div>
      </div>

      {/* Mobile bottom nav */}
      <div className="fixed bottom-3 left-3 right-3 z-40 rounded-[28px] border border-slate-200 bg-white/95 p-2 shadow-[0_16px_60px_rgba(15,23,42,0.16)] backdrop-blur lg:hidden">
        <div className="flex gap-1">
          <MobileNavItem
            to="/patient/dashboard"
            icon="dashboard"
            label="Home"
            match={isDashboard}
          />
          <MobileNavItem
            to="/patient/appointments"
            icon="calendar"
            label="Visits"
          />
          <MobileNavItem
            to="/patient/invoices"
            icon="invoice"
            label="Bills"
          />
          <MobileNavItem
            to="/patient/tickets"
            icon="ticket"
            label="Help"
          />
        </div>
      </div>
    </div>
  );
}